import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Always use Vietnamese ('vi') as the language
  const [language, setLanguage] = useState("vi");

  // Language change function - can be kept for backward compatibility
  // but will always set to Vietnamese
  const changeLanguage = (newLang) => {
    // Ignore the requested language and always set to Vietnamese
    setLanguage("vi");
    localStorage.setItem("language", "vi");
  };

  useEffect(() => {
    // On component mount, always set language to Vietnamese
    setLanguage("vi");
    localStorage.setItem("language", "vi");
  }, []);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
